import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;

//字典列表
export const GetSysDictLs = params => {
    return axios.get(`${base}/api/SysDict/GetSysDictGroupLs`, { params: params });
};
//通过code查询字典信息
export const GetSysDictByCode = params => {
    return axios.get(`${base}/api/SysDict/GetDictByCode`, { params: params });
};
//更新字典信息
export const UpdateSysDic = data => {
    return axios.post(`${base}/api/SysDict/AddSysDictList`, data);
};
//删除字典
export const DelSysDic = Id => {
    return axios.get(`${base}/api/SysDict/DeleteSysDictByIds?Id=${Id}`);
};
//添加字典
export const AddSysDict = data => {
    return axios.post(`${base}/api/SysDict/AddSysDict`, data);
};